// @ts-nocheck
import { useNavigate } from 'react-router-dom';

import { GithubLogo } from '@phosphor-icons/react';
import { Text, XStack, YStack } from 'tamagui';

import { useIsMobile } from '../../hooks/useIsMobile';
import { PRODUCT_NAME, NAV_LINKS } from './constants';
import { USE_CASES } from '../../pages/use-cases/useCaseData';

export function Footer() {
  const isMobile = useIsMobile();
  const navigate = useNavigate();

  const handleNavClick = (href: string, external?: boolean, route?: boolean) => {
    if (external) {
      window.open(href, '_blank');
      return;
    }
    if (route) {
      navigate(href);
      return;
    }
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <YStack
      tag="footer"
      paddingVertical="$7"
      paddingHorizontal="$5"
      borderTopWidth={1}
      borderColor="$borderColor"
    >
      <YStack
        maxWidth={1100}
        alignSelf="center"
        width="100%"
        gap="$6"
      >
        <XStack
          justifyContent="space-between"
          alignItems={isMobile ? 'flex-start' : 'center'}
          flexDirection={isMobile ? 'column' : 'row'}
          gap="$6"
        >
          {/* Logo and tagline */}
          <YStack gap="$2">
            <XStack alignItems="center" gap="$3">
              <XStack
                width={32}
                height={32}
                borderRadius="$3"
                alignItems="center"
                justifyContent="center"
                backgroundColor="$accentBackground"
              >
                <img
                  src="/torch.png"
                  alt={PRODUCT_NAME}
                  style={{ width: 18, height: 18 }}
                />
              </XStack>
              <Text fontSize={18} fontWeight="600" color="$color12" letterSpacing={-0.5}>
                {PRODUCT_NAME}
              </Text>
            </XStack>
            <Text fontSize={14} color="$color7" maxWidth={300}>
              Your work, one search away. Cross-ecosystem search and productivity for modern teams.
            </Text>
          </YStack>

          {/* Links */}
          <XStack gap={isMobile ? '$6' : '$8'} flexWrap="wrap">
            <YStack gap="$3">
              <Text fontSize={13} fontWeight="600" color="$color8" textTransform="uppercase" letterSpacing={1}>
                Product
              </Text>
              {NAV_LINKS.map((link) => (
                <Text
                  key={link.label}
                  fontSize={14}
                  color="$color9"
                  cursor="pointer"
                  hoverStyle={{ color: '$color12' }}
                  onPress={() => handleNavClick(link.href, (link as any).external, (link as any).route)}
                  style={{ transition: 'color 0.15s ease' } as any}
                >
                  {link.label}
                </Text>
              ))}
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => navigate('/pricing')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                Pricing
              </Text>
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => navigate('/getting-started')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                Getting Started
              </Text>
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => navigate('/security')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                Security
              </Text>
            </YStack>
            <YStack gap="$3">
              <Text fontSize={13} fontWeight="600" color="$color8" textTransform="uppercase" letterSpacing={1}>
                Use Cases
              </Text>
              {USE_CASES.map((uc) => (
                <Text
                  key={uc.slug}
                  fontSize={14}
                  color="$color9"
                  cursor="pointer"
                  hoverStyle={{ color: '$color12' }}
                  onPress={() => navigate(`/use-cases/${uc.slug}`)}
                  style={{ transition: 'color 0.15s ease' } as any}
                >
                  {uc.title}
                </Text>
              ))}
            </YStack>
            <YStack gap="$3">
              <Text fontSize={13} fontWeight="600" color="$color8" textTransform="uppercase" letterSpacing={1}>
                Compare
              </Text>
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => navigate('/compare/torch-vs-notion')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                Torch vs Notion
              </Text>
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => navigate('/compare/torch-vs-glean')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                Torch vs Glean
              </Text>
            </YStack>
            <YStack gap="$3">
              <Text fontSize={13} fontWeight="600" color="$color8" textTransform="uppercase" letterSpacing={1}>
                Company
              </Text>
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => navigate('/about')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                About
              </Text>
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => window.open('https://logicalbytes.dev', '_blank')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                Blog
              </Text>
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => navigate('/privacy')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                Privacy
              </Text>
              <Text
                fontSize={14}
                color="$color9"
                cursor="pointer"
                hoverStyle={{ color: '$color12' }}
                onPress={() => navigate('/terms')}
                style={{ transition: 'color 0.15s ease' } as any}
              >
                Terms
              </Text>
            </YStack>
          </XStack>
        </XStack>

        {/* Bottom bar */}
        <YStack
          height={1}
          backgroundColor="$color4"
        />
        <XStack
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap="$4"
        >
          <Text fontSize={13} color="$color7">
            &copy; {new Date().getFullYear()} SID Technologies. All rights reserved.
          </Text>
          <XStack gap="$4" alignItems="center">
            <GithubLogo
              size={18}
              color="var(--color8)"
              cursor="pointer"
              onClick={() => window.open('https://github.com', '_blank')}
            />
          </XStack>
        </XStack>
      </YStack>
    </YStack>
  );
}
